import { Box, Center, Flex, Heading, List, ListIcon, ListItem, SimpleGrid } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { CheckIcon, DefaultContainer } from '@/shared/ui';

const HowItWorkBlock = () => {
  const { t } = useTranslation();
  const howWork = t('mainPage.howItWorks.steps', { returnObjects: true }) as Array<{
    heading: string;
    items: string[];
  }>;

  return (
    <DefaultContainer gap='2xl'>
      <Heading
        size={{ base: 'xl', md: '2xl' }}
        textAlign='center'
      >
        {t('mainPage.howItWorks.heading')}
      </Heading>

      <SimpleGrid
        columns={{ base: 1, md: 3 }}
        spacing='xl'
        alignItems='stretch'
      >
        {howWork.map(({ heading, items }, index) => (
        <Box
          key={heading}
          position='relative'
          pt='xl'
          h='full'
        >
          <Center
            position='absolute'
            bg='bg.light'
            color='primary.pure'
            boxSize={16}
            top='0'
            mx='auto'
            left='calc(50% - 32px)'
            fontSize='4xl'
            fontWeight='bold'
            borderRadius='xl'
          >
            {index + 1}
          </Center>

          <Flex
            pt={10}
            pb={{ base: 'lg', md: 'xl' }}
            px={{ base: 'lg', md: 'xl' }}
            bg='bg.light'
            borderRadius='xl'
            flexDir='column'
            gap='md'
            h='full'
          >
            <Heading
              as='h3'
              size='lg'
              textAlign='center'
            >
              {heading}
            </Heading>

            <List
              display='flex'
              flexDir='column'
              gap='xs'
            >
              {items.map((text) => (
                <ListItem
                  key={text}
                  display='flex'
                >
                  <ListIcon
                    mt='1'
                    as={CheckIcon}
                    color='green.500'
                  />
                  {text}
                </ListItem>
              ))}
            </List>
          </Flex>
        </Box>
        ))}
      </SimpleGrid>
    </DefaultContainer>
  );
};

export default HowItWorkBlock;
